import React from 'react';
import { Provider } from 'react-redux';
import store from '../../state';

import NewDutyRequestForm from './NewDutyRequestForm';

const NewDutyRequestFormContainer = props => (
  <Provider store={store}>
    <NewDutyRequestForm {...props} />
  </Provider>
);

export default NewDutyRequestFormContainer;
